import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import splitOnUpperCase from "../../../utils/helpers/split-words";
import priceFormatter from "../../../utils/helpers/price-formatter";
import CarImage from "./images/car-img.svg";
import EDIT from "./images/edit.svg";
import styles from "./styles.css";
import { AB_TEST_VARIATIONS } from "../../../constants/app-constants";

const SellTradeInCarValuation = ({
    tradeInData,
    heading,
    description
}) => {

    const history = useHistory();

    const { offeredPrice = 0, vehicleMetaData = {}, odometerReading = 0, c2bOrderId, cohortVariant: sellValuationVariant } = tradeInData || {};
    const { make = "", model = "", year = "", variant = "", transmission = "", imageUrl = "" } = vehicleMetaData;
    const carFullName = `${year} ${make} ${model}`;

    const handleEditDetails = () => {
        history.push(`/sell-my-car/car-details/${c2bOrderId}`);
    };

    return (
        <div styleName={"styles.outer"}>
            <React.Fragment>
                <div styleName={"styles.header"}>
                    <p styleName={"styles.trade"}>Sell or Trade-in your car</p>
                    <p styleName={"styles.edit"} onClick={handleEditDetails}> <img src={EDIT} />Edit details</p>
                </div>
                <div styleName={"styles.parentCard"}>
                    <h6 styleName={"styles.heading"}>{heading}</h6>
                    <p styleName={"styles.description"}>{description}</p>
                    <div styleName={"styles.car-card"}>
                        <div styleName={"styles.car-details"}>
                            <div>
                                <img src={imageUrl || CarImage} />
                            </div>
                            <div>
                                <p styleName={"styles.modal"}>{carFullName}</p>
                                <p styleName={"styles.variant"}>{variant}</p>
                                <ul styleName={"styles.transmission"}>
                                    <li>{splitOnUpperCase(transmission)}</li>
                                    { odometerReading > 0 && <li>{`${priceFormatter(odometerReading)} kms`}</li> }
                                </ul>
                            </div>
                        </div>
                        {sellValuationVariant !== AB_TEST_VARIATIONS.VARIANT_B && <div>
                            <p styleName={"styles.valuation"}>{ sellValuationVariant === "VARIANT_C" ? "Max Valuation" : "Car’s valuation"}</p>
                            <p styleName={"styles.price"}>{ offeredPrice > 0 ? makePriceLabelRound(offeredPrice) : "N/A"}</p>
                        </div>}
                    </div>
                </div>
            </React.Fragment>
        </div>
    );
};

SellTradeInCarValuation.propTypes = {
    tradeInData: PropTypes.object,
    heading: PropTypes.string,
    description: PropTypes.string
};

export default SellTradeInCarValuation;
